import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import "./DashboardApp.css";

// Layout
import Sidebar from "./components/Sidebar.jsx";

// Super Admin
import OrganizationsAdmin from "./pages/admin/Organizations.jsx";
import OrganizationDetailsAdmin from "./pages/admin/OrganizationDetails.jsx";
import DirectoryInsightsAdmin from "./pages/admin/DirectoryInsights.jsx";
import DirectoryLeaguesAdmin from "./pages/admin/DirectoryLeagues.jsx";
import DirectoryLeagueClaimsAdmin from "./pages/admin/DirectoryLeagueClaims.jsx";

// Dashboard
import UserSettings from "./pages/Dashboard/Account/UserSettingsPage.jsx";
import ManageListing from "./pages/Dashboard/DirectoryListings/ManageListing.jsx";
import EditUserProfile from "./pages/Dashboard/Profile/EditUserProfile.jsx";

// Page Builder
import StartPage from "./pages/Dashboard/PageBuilder/Pages/StartPage.jsx";
import DashboardStart from "./pages/Dashboard/PageBuilder/Wizard/DashboardStart.jsx";
import OrganizationHome from "./pages/Dashboard/PageBuilder/Pages/OrganizationHome.jsx";
import CreatePageWizard from "./pages/Dashboard/PageBuilder/Wizard/CreatePageWizard.jsx";
import EditOrganizationPage from "./pages/Dashboard/PageBuilder/Editor/EditOrganizationPage.jsx";
import WebsiteSettings from "./pages/Dashboard/PageBuilder/Editor/WebsiteSettings.jsx";
import NavbarSettings from "./pages//Dashboard/PageBuilder/Pages/NavbarSettings.jsx"
import SystemPageSettings from "./pages/Dashboard/PageBuilder/Pages/SystemPageSettings.jsx";

// League Management — Players
import PlayerAuth from "./pages/Dashboard/LeagueManagement/Player/Auth/PlayerAuth.jsx";
import PlayerListAuth from "./pages/Dashboard/LeagueManagement/Player/Auth/PlayerListAuth.jsx";

// League Management — Teams
import TeamAuth from "./pages/Dashboard/LeagueManagement/League/Auth/LeagueAuthComponents/LeagueTeamRosterAuth/LeagueTeamRosterAuth.jsx";
import TeamListAuth from "./pages/Dashboard/LeagueManagement/Team/Auth/TeamListAuth.jsx";
import TeamIdentityAuth from "./pages/Dashboard/LeagueManagement/Team/Auth/TeamAuth.jsx";

// League Management — Seasons and Leagues
import SeasonListAuth from "./pages/Dashboard/LeagueManagement/Season/Auth/SeasonList.jsx";
import SeasonAuth from "./pages/Dashboard/LeagueManagement/Season/Auth/Season.jsx";
import LeagueAuth from "./pages/Dashboard/LeagueManagement/League/Auth/LeagueAuth.jsx";

// League Management — Games
import GameAuth from "./pages/Dashboard/LeagueManagement/Game/Auth/GameAuth.jsx";

// League Management — Tournament
import DivisionPageAuth from "./pages/Dashboard/LeagueManagement/Tournament/Auth/DivisionPage/DivisionPage.jsx";
import TournamentStandingsAuth from "./pages/Dashboard/LeagueManagement/Tournament/Auth/Standings.jsx";

// League Management — Organization Features
import BrandingAuth from "./pages/Dashboard/LeagueManagement/Sponsors/Sponsors.jsx";
import StatAuth from "./pages/Dashboard/LeagueManagement/Stat/StatAuth.jsx";

// In Progress
import GamePeriod from "./pages/InProgress/GamePeriod/GamePeriod.jsx";
import PlayerAttributes from "./pages/InProgress/PlayerAttribute/PlayerAttributes.jsx";
import ScheduleBuilder from "./pages/InProgress/ScheduleBuilder/ScheduleBuilder.jsx";


// User Profile
import CreateUserProfile from "./pages/Dashboard/Profile/CreateUserProfile.jsx";

function DashboardApp() {
   const { isAuthenticated, loading } = useAuth();

   if (loading) return null;

   if (!isAuthenticated) {
      return <Navigate to="/" replace />;
   }

   return (
      <div className="dashboard-layout">
         <Sidebar />

         <main className="dashboard-content">
            <Routes>
               {/* Super Admin */}
               <Route
                  path="/admin/organizations"
                  element={<OrganizationsAdmin />}
               />
               <Route
                  path="/admin/organizations/:id"
                  element={<OrganizationDetailsAdmin />}
               />
               <Route
                  path="/admin/organizations/:id/branding"
                  element={<BrandingAuth />}
               />
               <Route
                  path="/admin/organizations/:id/stats"
                  element={<StatAuth />}
               />
               <Route
                  path="/admin/organizations/:id/game-periods"
                  element={<GamePeriod />}
               />
               <Route
                  path="/admin/organizations/:id/player-attributes"
                  element={<PlayerAttributes />}
               />
               <Route
                  path="/admin/directory-leagues"
                  element={<DirectoryLeaguesAdmin />}
               />
               <Route
                  path="/admin/directory-claims"
                  element={<DirectoryLeagueClaimsAdmin />}
               />
               <Route
                  path="/admin/directory-insights"
                  element={<DirectoryInsightsAdmin />}
               />

               {/* Dashboard Start */}
               <Route path="/start-page" element={<StartPage />} />
               <Route path="/dashboard-start" element={<DashboardStart />} />
               <Route
                  path="/profile/edit"
                  element={<EditUserProfile />}
               />
               {/* Page Builder */}
               <Route
                  path="/organizations/:id"
                  element={<OrganizationHome />}
               />
               <Route
                  path="/organizations/:id/website-settings"
                  element={<WebsiteSettings />}
               />
               <Route
                  path="/organizations/:id/navbar-settings"
                  element={<NavbarSettings />}
               />
               <Route
                  path="/page-builder/:orgId/pages/:pageId/edit"
                  element={<EditOrganizationPage />}
               />
               <Route
                  path="/:id/system-pages/:pageId/settings"
                  element={<SystemPageSettings />}
               />
               <Route path="/page-wizard" element={<CreatePageWizard />} />

               {/* Directory Listing */}
               <Route
                  path="/directory/manage/:id"
                  element={<ManageListing />}
               />

               {/* Players */}
               <Route path="/players/:id" element={<PlayerAuth />} />
               <Route path="/playerListAuth" element={<PlayerListAuth />} />

               {/* Teams */}
               <Route path="/teamListAuth" element={<TeamListAuth />} />
               <Route
                  path="/teamListAuth/:team_id"
                  element={<TeamIdentityAuth />}
               />
               <Route
                  path="/seasons/:season_id/leagues/:league_id/teams/:team_id"
                  element={<TeamAuth />}
               />

               {/* Games */}
               <Route path="/games/:id" element={<GameAuth />} />

               {/* Seasons and Leagues */}
               <Route path="/seasons" element={<SeasonListAuth />} />
               <Route path="/seasons/:id" element={<SeasonAuth />} />
               <Route
                  path="/seasons/:season_id/leagues/:id"
                  element={<LeagueAuth />}
               />

               {/* Tournament */}
               <Route
                  path="/seasons/:seasonId/divisions/:divisionId"
                  element={<DivisionPageAuth />}
               />
               <Route
                  path="/fab/standings"
                  element={<TournamentStandingsAuth />}
               />

               {/* Organization Features */}
               <Route path="/branding" element={<BrandingAuth />} />
               <Route path="/stats" element={<StatAuth />} />



               {/* User Settings */}
               <Route path="/userSettings" element={<UserSettings />} />
               <Route
                  path="/profile/create"
                  element={<CreateUserProfile />}
               />

               {/* In Progress */}
               <Route path="/gamePeriod" element={<GamePeriod />} />
               <Route
                  path="/playerAttributes"
                  element={<PlayerAttributes />}
               />
               <Route
                  path="/scheduleBuilder"
                  element={<ScheduleBuilder />}
               />
            </Routes>
         </main>
      </div>
   );
}

export default DashboardApp;